import React, { Children } from 'react';
import styled from 'styled-components';
import { breakpoints, spacing } from '@naf/theme';
export const ScrollList = ({
  children,
  className
}) => {
  const itemCount = Children.count(children);
  return /*#__PURE__*/React.createElement(Wrapper, {
    $itemCount: itemCount,
    className: className
  }, children);
};
export default ScrollList;
const Wrapper = styled.div.withConfig({
  displayName: "ScrollList__Wrapper",
  componentId: "sc-1foza2d-0"
})(["display:flex;overflow-x:auto;gap:0 ", ";> div{width:", " !important;}-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}@media (max-width:", "){-webkit-overflow-scrolling:touch;>{display:inline-flex;}}"], spacing.space16, ({
  $itemCount
}) => `calc(${100 / ($itemCount < 4 ? $itemCount : 4)}%)`, breakpoints.m);
//# sourceMappingURL=ScrollList.js.map